import React, { useState, forwardRef, useEffect, useContext } from 'react'
import Modal from '../modal/Modal';
import CustomSelect from '../select/CustomSelect';
import { LiaCalendarSolid } from 'react-icons/lia';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import UserDetails from '../../context/UserDetails';

const options = [
    {
        label: 'Recent Transactions',
        value: 'recent_transaction'
    },
    {
        label: 'Current Month',
        value: 'current_month'
    },
    {
        label: 'Last Month',
        value: 'last_month'
    },
    {
        label: 'Last 3 Month',
        value: 'last_3_months'
    },
    {
        label: 'Last 6 Month',
        value: 'last_6_months'
    },
    {
        label: 'Current Financial Year',
        value: 'current_financial_year'
    },
    {
        label: 'Last Finacial Year',
        value: 'last_financial_year'
    },
    {
        label: 'Select Date Range',
        value: 'custom'
    }
]

const formatOptions = [
    {
        label: 'PDF',
        value: 'PDF'
    },
    {
        label: 'XLS',
        value: 'XLS'
    },
    {
        label: 'TEXT',
        value: 'TEXT'
    },
]

const CustomDateInput = forwardRef(({ value, placeholder, onClick }, ref) => (
    <div className="custom-date-input" onClick={onClick} ref={ref}>
        <p className={!value ? 'placeholder' : ''}>{value || placeholder}</p>
        <span>
            <LiaCalendarSolid color='#2085f8' size={30} />
        </span>
    </div>
));

const DownloadModal = ({ show, selectedOption, onClose }) => {

    const [tab, setTab] = useState('download')
    const [selected, setSelected] = useState(options[0])
    const [format, setFormat] = useState(formatOptions[0])

    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)

    const { token } = useContext(UserDetails)

    useEffect(() => {
        setSelected(() => selectedOption)
    }, [selectedOption])

    const handleTabNavClick = e => {
        let _tab = e.target.getAttribute('data-nav-for')
        setTab(() => _tab)
    }

    const handleChange = value => {
        setSelected(value)
    }
    const handleFormatChange = value => {
        setFormat(value)
    }
    const handleStartChange = value => {
        setStart(value)
    }
    const handleEndChange = value => {
        setEnd(value)
    }

    const downloadPDF = async () => {
        const payload = {
            "filter_type": selected.value,
        }
        if (start && end) {
            const startDate = new Date(start); 
            const formattedStartDate = startDate.toISOString().slice(0, 10); 
            const endDate = new Date(end); 
            const formattedEndDate = endDate.toISOString().slice(0, 10); 

            payload["from_date"] = formattedStartDate
            payload["to_date"] = formattedEndDate
        }
        const response = await axios.post('api/users/download-statement/', payload, {
            responseType: 'blob',
            headers: {
                "Content-Type": 'application/json',
                "Authorization": 'Token ' + token
            }
        })
        if (response.status === 200) {
            const data = response.data
            const blob = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'statement.pdf';
            document.body.appendChild(a);
            a.click();

            URL.revokeObjectURL(url); // Clean up the temporary URL
            document.body.removeChild(a); // Remove the temporary anchor element
        }

    }

    return (
        <Modal show={show} onClose={onClose}>
            <p className='mb-3 text-center' style={{ position: 'sticky', top: '0', background: '#fff' }}>
                Account Statement
            </p>
            <div className='my-4'>
                <p>
                    <strong>Request</strong>
                </p>
                <div className='my-3'>
                    <div className='grid modal-tabs-nav grid-cols-2'>
                        <div>
                            <button className={`tab-nav-btn left-rounded ${tab === 'download' ? 'active' : ''}`} data-nav-for='download' onClick={handleTabNavClick}>DOWNLOAD</button>
                        </div>
                        <div>
                            <button className={`tab-nav-btn right-rounded ${tab === 'email' ? 'active' : ''}`} data-nav-for='email' onClick={handleTabNavClick}>EMAIL</button>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='mb-3'>
                        <p>
                            <strong>Duration</strong>
                        </p>
                        <CustomSelect options={options} onChange={handleChange} value={selected} />
                    </div>
                    {selected.value === 8 ? <div className='mb-3'>
                        <p>
                            <small><strong>Date Range</strong> </small>
                        </p>
                        <div className='mb-3'>
                            <DatePicker
                                selected={start}
                                selectsEnd={end}
                                onChange={handleStartChange}
                                placeholderText='From'
                                customInput={<CustomDateInput />}
                                isClearable={false}
                                wrapperClassName='custom-date-wrapper'
                            />
                        </div>
                        <div className='mb-3'>
                            <DatePicker
                                selected={end}
                                selectsStart={start}
                                onChange={handleEndChange}
                                placeholderText='To'
                                customInput={<CustomDateInput />}
                                isClearable={false}
                                wrapperClassName='custom-date-wrapper'
                            />
                        </div>
                    </div> : null}
                    {tab === 'download' ? <div className='mb-3'>
                        <p>
                            <strong>Format</strong>
                        </p>
                        <CustomSelect options={formatOptions} onChange={handleFormatChange} defaultValue={format} />
                    </div>
                        :
                        <div className='mb-3'>
                            <p>
                                <strong>Registerd Email</strong>
                            </p>
                            <p>
                                <small>e***************@gmail.com</small>
                            </p>
                            <p>
                                <small>Read <span className='link'>important information</span> before confirming</small>
                            </p>

                        </div>}
                    <div className='mb-3'>
                        <button className='block w-full text-center btn-blue py-2 link rounded-md' onClick={downloadPDF}> CONFIRM</button>
                    </div>
                    <div>
                        <button className='block w-full text-center btn-outline-blue py-2 link rounded-md' onClick={onClose}>CANCEL</button>
                    </div>

                </div>
            </div>
        </Modal>
    )
}

export default DownloadModal